import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { Trans, t } from "@lingui/macro";

import { i18n } from "base/i18n";
import { BaseDropdown } from "widgets/basedropdown";
import {
  SearchInput,
  SEARCH_TYPE,
  Checkbox,
  Button,
  BUTTON_SIZES,
  BUTTON_TYPES
} from "widgets/inputs";
import { Scrollbar, SCROLLBAR_THICKNESS } from "widgets/scrollbar";

import styles from "./eye.css";

import EyeIcon from "./eye.svg";
export function Eye(props) {
  const {
    dataSource,
    labelKey = "label",
    title = i18n._(t`Show/hide fields`),
    onCancel = () => {},
    onApply = () => {},
    selectedIds,
    disabledIds = [],
    max = 6,
    maxSelectionText = i18n._(t`You can select up to ${max} fields`),
    targetRenderer = TragetRendererComponent
  } = props;
  const [options, setOptions] = useState([]);
  const [currentIds, setCurrentIds] = useState([]);
  const [error, setError] = useState(null);
  useEffect(
    function updateOptions() {
      setOptions(dataSource);
    },
    [dataSource]
  );
  useEffect(
    function udpateCurrentIds() {
      setCurrentIds(selectedIds);
    },
    [selectedIds]
  );
  const onSelect = (id) => {
    if (currentIds.includes(id)) {
      setCurrentIds(currentIds.filter((cid) => cid !== id));
    } else if (currentIds.length < max) {
      setCurrentIds([...currentIds, id]);
    } else {
      setError(id);
      setTimeout(() => {
        setError(null);
      }, 500);
    }
  };

  const onSearch = (value) => {
    let searchValue = value && value.trim();
    const filterList =
      dataSource &&
      dataSource.filter(
        (data) =>
          data[labelKey].toLowerCase() &&
          data[labelKey].toLowerCase().includes(searchValue.toLowerCase())
      );
    setOptions(filterList);
  };

  return (
    <BaseDropdown
      targetRenderer={() => targetRenderer({ title: title })}
      onClose={() => onSearch("")}
      listRenderer={({ closePopup }) => (
        <div className={styles.eyecontainer}>
          <SearchInput
            type={SEARCH_TYPE.MINIMAL}
            placeholder={i18n._(t`Search`)}
            onChange={(e) => {
              onSearch(e.target.value);
            }}
            onClear={() => onSearch("")}
          />
          <span className={`${styles.label} ${error ? styles.error : ""}`}>
            {maxSelectionText}
          </span>
          <Scrollbar
            thickness={SCROLLBAR_THICKNESS.THIN}
            style={{ flex: "1 1 100%" }}
          >
            <ul className={styles.list}>
              {options.map((item, index) => {
                return (
                  <li
                    key={index}
                    onClick={(e) => {
                      onSelect(item.Id);
                    }}
                    className={`${error === item.Id ? styles.error : ""} ${
                      disabledIds.includes(item.Id) ? styles.disabled : ""
                    }`}
                  >
                    <Checkbox
                      label={i18n._(item[labelKey])}
                      value={currentIds.includes(item.Id)}
                      style={{ pointerEvents: "none" }}
                    />
                  </li>
                );
              })}
            </ul>
          </Scrollbar>
          <div className={styles.actions}>
            <Button
              id="eyeComponentCancelBtn"
              type={BUTTON_TYPES.TERTIARY}
              size={BUTTON_SIZES.TINY}
              onClick={() => {
                setCurrentIds(selectedIds);
                onCancel();
                closePopup();
                onSearch("");
              }}
            >
              <Trans>Cancel</Trans>
            </Button>
            <Button
              id="eyeComponentApplyBtn"
              size={BUTTON_SIZES.TINY}
              onClick={() => {
                onApply(
                  dataSource.filter((option) => currentIds.includes(option.Id))
                );
                closePopup();
                onSearch("");
              }}
              data-heaplocator={`common-visibility-apply`}
            >
              <Trans>Apply</Trans>
            </Button>
          </div>
        </div>
      )}
    />
  );
}

Eye.propTypes = {
  dataSource: PropTypes.array,
  labelKey: PropTypes.string,
  onCancel: PropTypes.func,
  onApply: PropTypes.func,
  selectedIds: PropTypes.array,
  disabledIds: PropTypes.array,
  max: PropTypes.number,
  targetRenderer: PropTypes.func,
  title: PropTypes.string,
  maxSelectionText: PropTypes.string
};

TragetRendererComponent.propTypes = {
  title: PropTypes.string
};

function TragetRendererComponent({ title }) {
  return (
    <Button
      id="showHideFields"
      type={BUTTON_TYPES.ACTION}
      leftIcon={<EyeIcon />}
      size={BUTTON_SIZES.SMALL}
    >
      {title}
    </Button>
  );
}
